import { createContext, useReducer } from 'react';
import { UserState } from '../state/user.state';
import { UserRes } from '../response/user.response';
import { UserReducer } from '../reducer/user.reducer';
import { UserService } from '../service/user.service';
import { SecurityManager } from '../security/security-manager';
import { UserAction } from '../action/user.action';
import { CandidateConfig } from '../response/candidate.response';

const initialState = {
  userRes: {} as UserRes,
} as UserState;

export const UserContext = createContext<any>(initialState);

export const UserStateProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(UserReducer, initialState);

  const fetchUser = async () => {
    const [userRes, err] = await UserService.getUserById(
      SecurityManager.getUid(),
    );

    if (err) {
    } else {
      dispatch({
        type: UserAction.SET_USER,
        payload: {
          userRes: userRes,
        },
      });

      const [candidateConfig, err] = await UserService.config();

      if (err) {
      } else {
        dispatch({
          type: UserAction.UPDATE_CANDIDATE_CONFIG,
          payload: {
            candidateConfig: candidateConfig,
          },
        });
      }
    }
  };

  const updateCandidateConfig = (candidateConfig: CandidateConfig) => {
    dispatch({
      type: UserAction.UPDATE_CANDIDATE_CONFIG,
      payload: { candidateConfig },
    });
  };

  const value = {
    userRes: state.userRes,
    candidateConfig: state.candidateConfig,
    fetchUser: fetchUser,
    updateCandidateConfig: updateCandidateConfig,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
